import {
  ExistingRfnButton,
  ExistingRfnButtonSection,
  ImgContainer,
  MainContent,
  Subtitle,
  SvgImg,
  TextHeader,
  Title,
} from './ExistingRefinancedLoanStyledComponents';
import suscriptionAvailable from '../../assets/images/suscriptionAvailable.svg';
import PostMessageService from '../../services/PostMessage';
import { useEffect, useState } from 'react';
import ViewModeService from '../../services/ViewMode';

interface ExistingRefinancedLoanProps {
  loadingEvent: (data?: any) => void;
}

export const ExistingRefinancedLoan: React.FC<ExistingRefinancedLoanProps> = ({
  loadingEvent,
}) => {
  const [isApp, setisApp] = useState<boolean>(false);
  const [device, setDevice] = useState<string | null>(null);

  const handleContinue = () => {
    if (isApp && device === 'android') {
      window.location.href = 'peppermerchants://home';
    } else {
      PostMessageService.closeCEX();
    }
  };

  useEffect(() => {
    loadingEvent(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setisApp(ViewModeService.getViewMode() === 'APP' ? true : false);
    setDevice(ViewModeService.getDevice());
  }, [isApp, device]);

  return (
    <>
      <MainContent>
        <TextHeader>Información importante</TextHeader>
        <Title>¡Operación ampliable!</Title>
        <Subtitle>
          Este cliente tiene una operación ampliable, por favor regresa al menú
          principal y selecciónala para continuar.
        </Subtitle>
        <ImgContainer>
          <SvgImg src={suscriptionAvailable} alt="Suscription available" />
        </ImgContainer>
      </MainContent>
      <ExistingRfnButtonSection>
        <ExistingRfnButton onClick={handleContinue}>Cerrar</ExistingRfnButton>
      </ExistingRfnButtonSection>
    </>
  );
};
